<style>
    .moderation-holder {
        z-index: 1000;
        width: 100%;
    }

    .moderation-header {
        display: flex;
        width: 100%;
        max-width: 100%;
        background-color: black;
    }

    .header-link {
        padding: 15px;
        color: lightblue;
    }

    .logo {
        color: white;
    }

    .user-holder {
        flex: 1;
        padding: 15px;
        text-align: right;
        color: white;
    }

    @media (max-width:972px) {
        .moderation-header {
            font-size: 12px;
        }

        .header-link {
        padding: 5px;
        }
	}
</style>

<script>
    import {onMount} from 'svelte'
    import {push} from '../pt-router/Router.svelte'
    import * as Common from '../Common.js'
    import ReportedContentView from '../Moderation/ReportedContentView.svelte'
    import ShadowBannedView from '../Moderation/ShadowBannedView.svelte'
    import UnscreenedView from '../Moderation/UnscreenedView.svelte'
    import Notifications from '../Notifications.svelte'
    import CreateAreaView from '../Moderation/CreateAreaView.svelte'

    export let params
    let ready = false

    $: refreshed = params && Common.updateLoggedInUser(() => {
        if(!Common.currentUserValue) {
            Common.loginContext.update(v => "moderation/" + params.id)
            push('/login')
        }
        ready = true
    })
</script>

<svelte:head>
	<title>Plan Together - Moderation</title>
</svelte:head>

{#if ready}
    <div class="moderation-holder">
        <div class="moderation-header">
            <a class="header-link logo" href="/">plantogether</a>
            <a class="header-link" href="/moderation/reported">Reported</a>
            <a class="header-link" href="/moderation/banned">Banned</a>
            <a class="header-link" href="/moderation/unscreened">Unscreened</a>
            <a class="header-link" href="/moderation/add-area">Add Area</a>
            <div class="user-holder">
                {Common.currentUserValue.user_name}
            </div>
            <a class="header-link" href="#" on:click={() => Common.logUserOut()}>Log Out</a>
        </div>
        {#if params.id === "reported"}
            <ReportedContentView></ReportedContentView>
        {:else if params.id === "banned"}
            <ShadowBannedView></ShadowBannedView>
        {:else if params.id === "unscreened"}
            <UnscreenedView></UnscreenedView>
        {:else if params.id === "add-area"}
            <CreateAreaView></CreateAreaView>
        {:else}
            <p>
                Please select a moderation page.
            </p>
        {/if}
    </div>
    <Notifications></Notifications>
{/if}